import colors from 'colors'
import Button from 'components/Button'
import { HStack } from 'components/Stack'
import React, { FC } from 'react'
import styled from 'styled-components'
import { Result } from 'types'
import { getSpiritImage, getSpiritSpecsImage } from 'utils'

const Spirit = styled.div`
  margin-top: 16px;
  color: ${colors.beige};
  font-size: 20px;
`
const Title = styled.div`
  margin-top: 4px;
  color: ${colors.beige};
  font-size: 16px;
`
const SpiritImgWrapper = styled.div`
  margin: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
`
const SpiritImg = styled.img`
  max-width: 100%;
`
const TwitterBtn = styled(Button)`
  margin: 8px 0;
  width: 260px;
`

const twitterShare = (text: string, url: string, hashtags: string[]) => {
  const _hashtags = hashtags.map(a => encodeURI(a)).join(',')
  const a = `http://twitter.com/share?text=${encodeURI(text)}&url=${encodeURI(
    url,
  )}&hashtags=${_hashtags}`
  window.open(a, '_blank')
}

const Top: FC<{ code: string; result: Result }> = ({ code, result }) => {
  return (
    <>
      <Spirit>「{result.name}の精霊」</Spirit>
      <Title>{result.title}</Title>
      <HStack>
        <SpiritImgWrapper>
          <SpiritImg src={getSpiritImage(code)} />
        </SpiritImgWrapper>
        <SpiritImgWrapper>
          <SpiritImg src={getSpiritSpecsImage(code)} />
        </SpiritImgWrapper>
      </HStack>
      <TwitterBtn
        onClick={() =>
          twitterShare(
            result.shareText,
            `https://coinjinja.com/toushi-shindan/og/${code}.html`,
            ['仮想通貨投資タイプ診断', '取引所診断'],
          )
        }
      >
        Twitterで共有
      </TwitterBtn>
    </>
  )
}

export default Top
